type ColorArray = string[];

interface ColorConfig {
  [key: string]: string | ColorArray;
}

export interface ConvertedColors {
  [key: string]: string;
}

export default function (colors: ColorConfig): ConvertedColors {
  if (!colors) {
    return {};
  }

  const result: ConvertedColors = {};

  Object.entries(colors).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      value.forEach((color, index) => {
        const shade = `${key}-${(index + 1) * 100}`;
        result[shade] = color;
      });
    } else {
      result[key] = value;
    }
  });

  return result;
}
